import React from "react";

import { Container, Nav, NavDropdown, NavLink, Navbar, NavbarBrand, NavbarCollapse } from "react-bootstrap";

import classNames from "classnames";
import { Link, useLocation } from "react-router-dom";
import { ReactSVG } from "react-svg";

import logo from "@assets/rrs-logo.svg";
import { ProtectedComponent } from "@components/permission_control/ProtectedComponent";
import { useAuthenticationContext } from "@context/authentication";
import { UserDropDownMenu } from "@pages/UserMenu/UserDropDownMenu";

import { ROUTES } from "../../routes";

import styles from "./PublicHeader.module.scss";

// TODO: Proper useMatch
const SIGN_IN_BUTTON_PATHS = {
  internal: "/internal/signin",
  external: "/external",
};

export const PublicHeader = () => {
  const { auth } = useAuthenticationContext();
  const { pathname } = useLocation();

  const isInternalSignIn = pathname === SIGN_IN_BUTTON_PATHS.internal;
  const signInText = isInternalSignIn ? "Sign in with Okta" : "Sign in";

  return (
    <Navbar expand="md" sticky="top" className={styles["public-header"]}>
      <Container fluid className="p-0">
        <div className="w-100 d-flex justify-content-between align-items-center">
          <div className={classNames(styles["left-links"])}>
            <Navbar.Toggle aria-controls="navbar-left-links" />
            <NavbarCollapse id="navbar-left-links">
              <Nav>
                <NavLink className="pl-0" as={Link} to={ROUTES.NoticeOfResale.path}>
                  Notice of Resale
                </NavLink>
                <NavDropdown title="More info" renderMenuOnMount>
                  <NavDropdown.Item as={Link} to={ROUTES.MoreInfo.Artist.path}>
                    Artist
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item as={Link} to={ROUTES.MoreInfo.AMP.path}>
                    Art market professional
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item as={Link} to={ROUTES.MoreInfo.AC.path}>
                    Art centre
                  </NavDropdown.Item>
                </NavDropdown>
                <NavLink as={Link} to={ROUTES.ContactUs.path}>
                  Contact us
                </NavLink>
              </Nav>
            </NavbarCollapse>
          </div>
          <NavbarBrand as={Link} to={ROUTES.Root.path} className={classNames(styles["logo"], "d-flex", "flex-column")}>
            <ReactSVG src={logo} />
          </NavbarBrand>
          <Nav className={classNames(styles["right-links"])}>
            {/* TODO NRRS-170: Have user menu when signed in which has options, dashboard, etc */}
            {!auth && (
              <NavLink as={Link} to={ROUTES.ExternalRegister.path}>
                Register
              </NavLink>
            )}
            {!auth && (
              <NavLink as={Link} to={isInternalSignIn ? ROUTES.InternalSignIn.path : ROUTES.ExternalSignIn.path}>
                {signInText}
              </NavLink>
            )}

            <ProtectedComponent auth={auth}>
              <UserDropDownMenu />
            </ProtectedComponent>
          </Nav>
        </div>
      </Container>
    </Navbar>
  );
};
